.completed {
  margin-right: 0 !important;
  color: green !important;
}

.notCompleted {
  margin-right: 0 !important;
}
